export default __webpack_public_path__ + "assets/icon-cart-plus.0e6169b4.webp";